import typedDelegateSelectors from "state/delegate";
import { selectors as customizationsSelectors } from "state/tree/homePageV1/customizations/customizationsSelectors";
import { selectors as showRoomStreamsSelectors } from "state/tree/homePageV1/showRoomStreams/showRoomStreamsSelectors";

export const selectors = {
  ...typedDelegateSelectors(customizationsSelectors, "customizations"),
  ...typedDelegateSelectors(showRoomStreamsSelectors, "showRoomStreams"),
};
